import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "price",
    "period",
    "savings",
    "annualBilled",
    "intervalInput",
    "monthlyBtn",
    "annualBtn",
  ];
  static values = {
    annualDiscountRate: Number,
  };

  connect() {
    this.interval = "month";
  }

  toggleToMonthly() {
    this.interval = "month";
    this.updatePricing();
  }

  toggleToAnnual() {
    this.interval = "year";
    this.updatePricing();
  }

  updatePricing() {
    const isAnnual = this.interval === "year";

    // Update price display (if targets exist)
    if (this.hasPriceTarget) {
      this.priceTargets.forEach((priceEl) => {
        const monthlyPrice = parseFloat(priceEl.dataset.monthlyPrice);

        // Show discounted monthly price in annual mode, regular monthly price otherwise
        const displayPrice = isAnnual
          ? monthlyPrice * (1 - this.annualDiscountRateValue)
          : monthlyPrice;

        priceEl.textContent = Math.round(displayPrice) + "€";
      });
    }

    // Update period text (always show /mois now)
    if (this.hasPeriodTarget) {
      this.periodTargets.forEach((periodEl) => {
        periodEl.textContent = "/mois";
      });
    }

    // Update annual billed amount (if targets exist)
    if (this.hasAnnualBilledTarget) {
      this.annualBilledTargets.forEach((annualBilledEl) => {
        if (isAnnual) {
          const monthlyPrice = parseFloat(annualBilledEl.dataset.monthlyPrice);
          const discountedMonthlyPrice = monthlyPrice * (1 - this.annualDiscountRateValue);
          const annualTotal = Math.round(discountedMonthlyPrice * 12);
          const formattedAmount = annualTotal.toLocaleString('fr-FR');
          annualBilledEl.textContent = `Facturé ${formattedAmount}€/an`;
          annualBilledEl.classList.remove("hidden");
        } else {
          annualBilledEl.classList.add("hidden");
        }
      });
    }

    // Hide savings message (no longer needed)
    if (this.hasSavingsTarget) {
      this.savingsTargets.forEach((savingsEl) => {
        savingsEl.classList.add("hidden");
      });
    }

    // Update hidden interval inputs (if targets exist)
    if (this.hasIntervalInputTarget) {
      this.intervalInputTargets.forEach((input) => {
        input.value = this.interval;
      });
    }

    // Update button active states
    if (this.hasMonthlyBtnTarget && this.hasAnnualBtnTarget) {
      const monthlyBtn = this.monthlyBtnTarget;
      const annualBtn = this.annualBtnTarget;

      if (isAnnual) {
        monthlyBtn.classList.remove("bg-default-600", "text-white");
        monthlyBtn.classList.add("text-gray-700", "hover:bg-gray-50");
        annualBtn.classList.add("bg-default-600", "text-white");
        annualBtn.classList.remove("text-gray-700", "hover:bg-gray-50");
      } else {
        monthlyBtn.classList.add("bg-default-600", "text-white");
        monthlyBtn.classList.remove("text-gray-700", "hover:bg-gray-50");
        annualBtn.classList.remove("bg-default-600", "text-white");
        annualBtn.classList.add("text-gray-700", "hover:bg-gray-50");
      }
    }
  }
}
